module.exports = __webpack_public_path__ + "static/media/font-awesome-logo-full.42bdf506.svg";